export default __webpack_public_path__ + "static/media/ic_weth_40.2dd52bee.svg";